<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      label-position="top"
    >
      <div class="d-flex">
        <div class="d-flex" style="margin-right: 10px;">
          <el-avatar shape="square" :src="formData.bigImageUrl" :size="64">
            <span style="font-size: 20px;">LOGO</span>
          </el-avatar>
        </div>
        <el-row :gutter="10" class="flex-grow-1">
          <el-col :span="16">
            <el-form-item
              :label="$l('form_label_custName') || '客户公司名称'"
              prop="custCode"
            >
              <dict-select
                v-model="formData.custCode"
                :selectedLabel.sync="formData.custName"
                url="/master/common/dict/customerSelectByStatus"
                :body="{ dictType: ['W', 'B', 'P', 'Y'] }"
                :placeholder="$l('form_placeholder_cust') || '请选择客户'"
                filterable
                clearable
                style="width: 100%"
                @change="custChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_custShortName') || '客户简称'">
              <el-input v-model="formData.custShortName" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_dep') || '费用部门'"
            prop="depCode"
          >
            <dep-cascader
              :lastValue.sync="formData.depCode"
              :pathLabels.sync="formData.orgDepFullName"
              :placeholder="$l('form_placeholder_dep') || '请选择费用部门'"
              size="small"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :modal="false"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  data() {
    return {
      backDialogVisible: false,
      formData: {
        custCode: '',
        custName: '',
        custShortName: '',
        bigImageCode: '',
        bigImageUrl: '',
        depCode: '',
        orgDepFullName: '',
      },
      rules: {
        custCode: [
          {
            required: true,
            message: this.$l('form_placeholder_cust') || '请选择客户',
            trigger: 'change',
          },
        ],
        depCode: [
          {
            required: true,
            message: this.$l('form_placeholder_dep') || '请选择费用部门',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async custChange(custCode) {
      const getCustomerInfo = async () => {
        if (!custCode) return {}
        const res = await this.$api
          .masterCustomerV2DetailApi({ custCode })
          .catch(() => null)
        if (!res) return
        return res.body || {}
      }

      const data = await getCustomerInfo()
      this.formData.custShortName = data.custShortName
      this.formData.bigImageCode = data.bigImageCode
      this.formData.bigImageUrl = data.bigImageUrl
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()
      const res = await this.$api
        .masterCustomerCostSectorAddApi(this.formData)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_add_no') || '新增失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_add_ok') || '新增成功！',
        type: 'success',
      })

      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
